
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Trophy, ArrowRight, Users, TrendingUp } from 'lucide-react';

const AgentBetaSection: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-black to-[#0d1117] text-white relative overflow-hidden w-full">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-500/20 border border-orange-500/30 mb-6">
              <Trophy className="h-5 w-5 text-orange-400" />
              <span className="text-sm font-bold text-orange-400">FOUNDING AGENT BETA</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Are You an <span className="text-orange-400">Agent, Scout, or NIL Professional?</span>
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Join our exclusive Founding Agent Beta program and get early access to powerful athlete discovery and management tools.
            </p>
          </div>

          {/* Features Grid */}
          <div className="grid md:grid-cols-3 gap-6 mb-10">
            <div className="p-6 rounded-lg bg-white/5 border border-white/10">
              <div className="p-3 rounded-full bg-orange-500/20 w-fit mb-4">
                <Users className="h-6 w-6 text-orange-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Athlete Discovery</h3>
              <p className="text-sm text-gray-400">
                Access our database of emerging athletes and connect directly with prospects.
              </p>
            </div>
            <div className="p-6 rounded-lg bg-white/5 border border-white/10">
              <div className="p-3 rounded-full bg-orange-500/20 w-fit mb-4">
                <TrendingUp className="h-6 w-6 text-orange-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Special Pricing</h3>
              <p className="text-sm text-gray-400">
                Lock in exclusive founding member rates before our public launch.
              </p>
            </div>
            <div className="p-6 rounded-lg bg-white/5 border border-white/10">
              <div className="p-3 rounded-full bg-orange-500/20 w-fit mb-4">
                <Trophy className="h-6 w-6 text-orange-400" />
              </div>
              <h3 className="text-lg font-semibold mb-2">Early Access</h3>
              <p className="text-sm text-gray-400">
                Be the first to use new features and help shape the platform.
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="text-center">
            <Button asChild className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-6 h-auto text-lg rounded-md">
              <Link to="/agent-beta" className="flex items-center">
                Apply for Agent Beta Access
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgentBetaSection;
